import { call, put, takeEvery } from 'redux-saga/effects'
import { getBalances } from 'services/api/account'

import { actions } from './slice'

const fetchBalancesSaga = function* () {
  try {
    const { error, response } = yield call(getBalances)
    if (error) {
      yield put(actions.error())
      return
    }

    yield put(actions.setBalances(response))
  } catch (e) {
    yield put(actions.error())
  }
}

const accountSagas = function* () {
  yield takeEvery(actions.fetchBalances.type, fetchBalancesSaga)
}

export default accountSagas
